import React from "react";
import cx from "classnames";

const CLASS_ROOT = "modal-dialog__section";

const ModalSection = ({ className, ...other }) => {
  const classes = cx(CLASS_ROOT, className);

  return <div className={classes} {...other} />;
};

ModalSection.displayName = "ModalSection";

export default ModalSection;
